import { t } from '@/lib/i18n';
/**
 * BUG-001 (BUGS.md) — route-based `React.lazy()` uchun umumiy Suspense fallback.
 * TZ-docs/08 §8.5.15 — real skeleton, spinner emas; bu yerda bosh sahifa hali
 * aniq emas (rol/route hali yuklanmoqda), shuning uchun neytral, brendga mos
 * pulslovchi belgi ishlatiladi — public/index.html dagi #splash bilan bir xil uslub.
 */
export function RouteFallback() {
  return (
    <div className="fixed inset-0 z-40 grid place-items-center bg-canvas" role="status" aria-label={t('Yuklanmoqda')}>
      <div className="h-16 w-16 animate-pulse rounded-inner bg-inverse grid place-items-center p-3.5 shadow-card">
        <img src="/icons/wheat-plant.png" alt="Loading" className="h-full w-full object-contain" />
      </div>
    </div>
  );
}
